"use client";

import { motion } from "framer-motion";
import { useEffect } from "react";

const Terms = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-20"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-white p-8 shadow-lg md:p-12">
          <h1 className="mb-8 text-center text-4xl font-bold text-gray-900">
            Terms & Conditions
          </h1>

          <div className="prose prose-lg max-w-none leading-relaxed text-gray-700">
            <p className="mb-6 text-lg">
              Welcome to Nautilus Times. By accessing, browsing, or utilizing
              this platform and its maritime information services, you
              acknowledge and agree to be legally bound by the terms and
              stipulations contained herein. These provisions constitute a
              binding contractual framework between you and Nautilus Times.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              1. Acceptance of Terms
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Engagement with our website or services implies irrevocable
                acceptance of these Terms & Conditions.
              </li>
              <li>
                If you do not concur, you are advised to discontinue usage
                immediately.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              2. Eligibility & User Obligations
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Users must possess the requisite legal capacity to enter into
                binding agreements.
              </li>
              <li>
                You agree not to misuse, exploit, or manipulate the platform in
                any manner inconsistent with applicable laws, maritime
                regulations, or community standards.
              </li>
              <li>
                Credentials, subscriptions, and access privileges are strictly
                non-transferable.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              3. Service Provision & Limitations
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Nautilus Times reserves exclusive discretion to alter, suspend,
                or discontinue any service component without prior notification.
              </li>
              <li>
                The platform provides maritime news, insights, and related
                content on an "as is" and "as available" basis, with no express
                or implied warranties of accuracy, continuity, or suitability.
              </li>
              <li>
                Access may be interrupted due to maintenance, system upgrades,
                or external contingencies beyond our control.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              4. Intellectual Property Rights
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                All textual content, digital assets, logos, designs, databases,
                and proprietary compilations remain the intellectual property of
                Nautilus Times.
              </li>
              <li>
                Unauthorized reproduction, redistribution, republication, or
                derivative creation is prohibited without prior written consent.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              5. Payment & Non-Refundability
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                All payments, subscriptions, or transactions conducted via the
                platform are deemed final, conclusive, and non-reversible.
              </li>
              <li>
                No refund, reimbursement, or credit will be entertained, except
                where mandated by overriding legal compulsion.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              6. Liability Disclaimer
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Nautilus Times disclaims liability for loss, damage, or
                disruption resulting from reliance on the platform, including
                but not limited to inaccuracies, cyber incidents, or third-party
                failures.
              </li>
              <li>
                Users expressly acknowledge that engagement is undertaken at
                their own risk.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              7. Indemnification
            </h2>
            <p className="mb-4">
              You agree to indemnify and hold harmless Nautilus Times, its
              affiliates, and representatives against any claims, damages,
              liabilities, or expenses arising from:
            </p>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>Your misuse of the platform.</li>
              <li>Violation of these Terms & Conditions.</li>
              <li>
                Infringement of intellectual property or contractual rights of
                third parties.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              8. Governing Law & Jurisdiction
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                These Terms shall be governed and interpreted in accordance with
                prevailing maritime commerce principles and relevant legal
                frameworks.
              </li>
              <li>
                Any disputes shall be subject exclusively to the jurisdiction of
                the competent courts in India.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              9. Amendments
            </h2>
            <p className="mb-6">
              Nautilus Times reserves the sole authority to revise or update
              these Terms & Conditions at any time. Continued usage of the
              platform post-modification constitutes binding acceptance of such
              revisions.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Terms;
